import { render, staticRenderFns } from "./DonutChart.vue?vue&type=template&id=a9f79336&scoped=true&"
import script from "./DonutChart.vue?vue&type=script&lang=ts&"
export * from "./DonutChart.vue?vue&type=script&lang=ts&"
import style0 from "./DonutChart.vue?vue&type=style&index=0&id=a9f79336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f79336",
  null
  
)

export default component.exports